import { render, staticRenderFns } from "./new-flow-test.vue?vue&type=template&id=792c05dd&"
import script from "./new-flow-test.vue?vue&type=script&lang=js&"
export * from "./new-flow-test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports